const Events = {
  register: {
    ADD_DEPOSIT: 'register:account:add_deposit',
    ADD_DEPOSIT_REFUND: 'register:account:add_deposit_refund',
    PAYMENTS_START: 'payments:start',
    PAYMENTS_CLOSE: 'payments:close',
    PAYMENTS_FINISH: 'payments:finish',
    SALE_UPDATING: 'payments:sale:updating',
    SALE_UPDATED: 'payments:sale:updated',
    SHOW_PAYMENTS: 'payments:show',
    CONFIRM_FOR_UNSAVED_CHANGES: 'payments:sale:confirm:for:unsaved:changes',
    SHIPPING_UPDATED: 'payments:shipping:updated',
    DEPOSIT_REFUNDS_REQUESTED: 'payments:deposit:refunds:requested',
    QUICK_CASH_PAY_REQUESTED: 'payments:quick:cash:pay:requested',
    QUICK_CARD_PAY_REQUESTED: 'payments:quick:card:pay:requested',
    CANCEL_SALE_REQUESTED: 'payments:sale:cancel:requested',
    REGISTER_TIP_REASSIGN: 'payments:sale:tip:reassign:requested',
  },
};

export default class GlobalEvents {
  static get Events() {
    return Events;
  }
}
